/** PURE_IMPORTS_START .._util_isArray PURE_IMPORTS_END */
import { isArray } from '../util/isArray';
export function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
;
//# sourceMappingURL=isNumeric.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/util/isNumeric.js
// module id = ./node_modules/rxjs/_esm5/util/isNumeric.js
// module chunks = vendor